var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"hero-body"},[_c('h2',[_vm._v("The requested page timed out.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Click here to go to the home page")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }